import { linkEditing } from '@yola/ws-sdk';

const { linkTypes } = linkEditing.constants;

const getDefaultLinkTypes = () => [
  linkTypes.PAGE,
  linkTypes.PHONE,
  linkTypes.MAIL,
  linkTypes.DOWNLOAD,
  linkTypes.ANCHOR,
  linkTypes.EXTERNAL,
];

export default getDefaultLinkTypes;
